<template>
  <mu-card class="reg-form">
    <mu-card-header :title="$t('message.labelLetsGetStarted')"
                    titleClass="regTitle"></mu-card-header>
    <mu-card-text>
      <p v-if="!$route.query.hcp">Enter the basics to begin personalising your Low Carb Program experience. If
        you already have an account, <span v-if="model.offerCode"> <router-link :to="`/login?oc=${model.offerCode}`">click here to log in</router-link></span>
        <span v-else>
                  <router-link to="/login">click here to log in</router-link>
                </span>
      </p>

      <p v-if="$route.query.hcp">Join the free Healthcare Professional Platform</p>
      <form v-on:submit.prevent="submitForm">

        <mu-flexbox align="baseline">
          <mu-flexbox-item>
            <mu-text-field
              id="firstnameTxt"
              v-validate="{required:true, max: 40}"
              data-vv-name="first_name"
              data-vv-value-path="inputValue"
              data-vv-validate-on="none"
              :data-vv-as="$t('message.accountPreferencesFirstName')"
              :errorText="errors.first('first_name')"
              :label="$t('message.labelYourName')"
              type="text"
              v-model="model.firstname"
              :hintText="$t('message.accountPreferencesFirstName')"
              fullWidth
              :disabled="prefilled.firstname"
            >
            </mu-text-field>
          </mu-flexbox-item>
          <mu-flexbox-item>
            <mu-text-field
              id="surnameTxt"
              v-validate="{required:true, max: 40}"
              data-vv-name="last_name"
              data-vv-value-path="inputValue"
              data-vv-validate-on="none"
              :data-vv-as="$t('message.accountPreferencesSurname')"
              :errorText="errors.first('last_name')"
              type="text"
              v-model="model.surname"
              :hintText="$t('message.accountPreferencesSurname')"
              fullWidth
              :disabled="prefilled.surname"
            >
            </mu-text-field>
          </mu-flexbox-item>
        </mu-flexbox>

        <mu-text-field
          id="emailTxt"
          v-validate="'required|email'"
          data-vv-name="email"
          data-vv-value-path="inputValue"
          data-vv-validate-on="none"
          :data-vv-as="$t('message.accountPreferencesEmail')"
          :errorText="errors.first('email')"
          :label="$t('message.accountPreferencesEmail')"
          type="email"
          v-model="model.email"
          :hintText="$t('message.placeholderEmail')"
          fullWidth
          :disabled="prefilled.email"
        ></mu-text-field>

        <div class="mu-text-field-label">
          Date of birth
        </div>

        <mu-row>
          <mu-col desktop="33" tablet="33" width="33">
            <select
              name="birth_day"
              v-validate
              :class="{'error': errors.first('birth_day')}"
              :data-vv-rules="'required'"
              data-vv-name="birth_day"
              data-vv-as="day"
              v-model="dob.day" class="native-select"
              :disabled="prefilled.dob"
            >
              <option :value="null">Day</option>
              <option
                v-for="(day, index) in dobItems.days"
                :key="'day-' + index"
                :value="day"
                :disabled="prefilled.dob"
              >{{day}}
              </option>
            </select>
          </mu-col>
          <mu-col desktop="33" tablet="33" width="33">
            <select
              name="birth_month"
              v-validate
              :class="{'error': errors.first('birth_month')}"
              :data-vv-rules="'required'"
              data-vv-name="birth_month"
              data-vv-as="month"
              v-model="dob.month" class="native-select"
              :disabled="prefilled.dob"
            >
              <option :value="null">Month</option>
              <option
                v-for="(month, index) in dobItems.months"
                v-once
                :key="'month-' + index"
                :value="month"
                :disabled="prefilled.dob"
              >{{localizeMonth(month.name)}}
              </option>
            </select>
          </mu-col>
          <mu-col desktop="33" tablet="33" width="33">
            <select
              name="birth_year"
              v-validate
              :class="{'error': errors.first('birth_year')}"
              :data-vv-rules="'required'"
              data-vv-name="birth_year"
              data-vv-as="year"
              v-model="dob.year"
              class="native-select"
              :disabled="prefilled.dob"
            >
              <option :value="null">Year</option>
              <option
                v-for="(year, index) in dobItems.years"
                v-once
                :key="'year-' + index"
                :value="year"
                :disabled="prefilled.dob"
              >{{year.value}}
              </option>
            </select>
          </mu-col>
        </mu-row>
        <p class="privacyDisclaimer" @click="setTerms">
          <mu-checkbox v-model="terms">
          </mu-checkbox>
          {{$t('message.registerTermsByContinuing')}}
          <a :href="`${siteUrl}terms`" target="_blank">{{$t('message.registerTermsAndCondtions')}}</a>
          {{$t('message.registerTermsJoin')}} <a :href="`${siteUrl}privacy`" target="_blank">{{$t('message.registerPrivacyPolicy')}}</a>,
          {{$t('message.registerIncluding')}}
          <a :href="`${siteUrl}privacy`" target="_blank">{{$t('message.registerIncludingCookie')}}</a>
        </p>

        <button type="submit" style="display: none;"></button>

        <mu-raised-button
          id="submitBtn"
          @click.native="submitForm()"
          type="button"
          :label="isSaving ? $t('message.labelProcessing') : $t('message.registerAppBarText')"
          :disabled="isSaving"
          secondary
          fullWidth
        ></mu-raised-button>
      </form>
      <transition name="fade">
        <alert type="danger" icon="error" v-if="isError" style="margin-top: 16px; margin-bottom: 0px;">
          <div slot="content">
            {{ $t('message.registerErrorUserExists') }}
          </div>
        </alert>
        <alert type="danger" icon="error" v-if="isTermsError" style="margin-top: 16px; margin-bottom: 0px;">
          <div slot="content">
            Please agree to our terms and conditions
          </div>
        </alert>
        <alert type="danger" icon="error" v-if="isServerValidationError"
               style="margin-top: 16px; margin-bottom: 0px;">
          <div slot="content">
            {{serverValidationErrorText}}
          </div>
        </alert>
      </transition>
    </mu-card-text>
  </mu-card>
</template>

<script>
  import MonthLocalizerMixin from "../../mixins/Localization/DateMonths";
  import SocialLoginMixin from "../../mixins/SocialLoginMixin";
  import RegistrationMixin from "../../mixins/RegistrationMixin";
  import PasswordStrengthValidation from "../PasswordStrengthValidation/PasswordStrengthValidation";
  import RegistrationApi from "../../api/Registration";

  export default {
    data() {
      return {
        prefilled: {
          firstname: false,
          surname: false,
          email: true,
          dob: false
        },
        submitFunc: RegistrationApi.complete
      }
    },
    computed: {

    },
    name: "CompleteSocialRegistration",
    mixins: [MonthLocalizerMixin, SocialLoginMixin, RegistrationMixin],
    components: {
      PasswordStrengthValidation
    },
    mounted() {
      const self = this;
      const user = self.$store.state.user.scope;
      if (user.firstname && user.firstname.length) {
        self.prefilled.firstname = user.firstname;
        self.model.firstname = user.firstname;
      }

      if (user.surname && user.surname.length) {
        self.prefilled.surname = user.surname;
        self.model.surname = user.surname;
      }

      if (user.email && user.email.length) {
        self.prefilled.email = user.email;
        self.model.email = user.email;
        self.model.emailVerify = user.email;
      }

      if (user.dob && user.dob.length) {
        self.prefilled.dob = user.dob;
        self.model.dob = user.dob;
        self.explodeDob();
      }
    },
    methods: {
      explodeDob() {
        const self = this;
        const dobBits = self.model.dob.toString().split('-');
        const yearObject = self.dobItems.years.find(elem => elem.value === dobBits[0]);
        const monthObject = self.dobItems.months.find(elem => elem.value === dobBits[1].toString());
        self.dob.day = dobBits[2];
        self.dob.month = monthObject;
        self.dob.year = yearObject;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// CompleteSocialRegistration.vue?1bdedbc8